export default __webpack_public_path__ + "static/media/Enzymes.ecdf2fe1.jpg";